export default __webpack_public_path__ + "static/media/18.93e3a17f.jpg";